import {
  FilterDataTypeEnum,
  FilterOperatorEnum,
  IAreaCodeEntity,
  IHttpSearchResponse,
  ISearchFilter,
  ISearchRequest,
} from '@gr/shared/models';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { defaultAreaCodeOptions } from '../components/SystemNumbers/types';
import { axiosPost } from '../authAxios';

function getSearchOptions(searchTerm: string): ISearchRequest {
  const searchFilter: ISearchFilter = !isNaN(Number(searchTerm))
    ? {
      dataType: FilterDataTypeEnum.NUMBER,
      fieldName: 'areaCode',
      operator: FilterOperatorEnum.CONTAINS,
      value: searchTerm,
    }
    : {
      dataType: FilterDataTypeEnum.STRING,
      fieldName: 'stateText',
      operator: FilterOperatorEnum.CONTAINS,
      value: searchTerm,
    };
  const nonSearchFilters = defaultAreaCodeOptions.filters.filter((filter) => filter.fieldName !== 'areaCode');

  return {
    ...defaultAreaCodeOptions,
    filters: searchTerm ? [...nonSearchFilters, searchFilter] : nonSearchFilters,
  };
}

export default function useAreaCodes(searchTerm: string) {
  return useQuery({
    queryKey: ['area-codes', searchTerm],
    queryFn: async () => {
      const axios = await axiosPost<IHttpSearchResponse<IAreaCodeEntity>>('entities-search', getSearchOptions(searchTerm));
      return axios.data?.data;
    },
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
}
